import React, {createContext, useCallback, useContext, useRef} from 'react';
import {DataById} from "../redux/map/types";
import {SelectedFeatureProperties} from "../redux/showInfo/types";


const FeaturesHighlightingContext = createContext({
    highlightedFeaturesById: {} as React.MutableRefObject<DataById<SelectedFeatureProperties>>,
    hoveredFeaturesRef: [] as unknown as React.MutableRefObject<SelectedFeatureProperties[]>,
    addHighlighted: (featureProperties: SelectedFeatureProperties) => {
        return;
    },
    removeAllHighlighted: () => {
        return;
    },
    addHovered: (featureProperties: SelectedFeatureProperties) => {
        return;
    }
});

const useFeaturesHighlightingContext = () => {
    return useContext(FeaturesHighlightingContext);
};

type ProviderProps = {
    children: React.ReactNode,
}

const FeaturesHighlightingContextProvider = ({children}: ProviderProps) => {
    const highlightedFeaturesById = useRef<DataById<SelectedFeatureProperties>>({});
    const hoveredFeaturesRef = useRef<SelectedFeatureProperties[]>([]);

    const addHighlighted = useCallback((featureProperties: SelectedFeatureProperties) => {
        const {featureStateId, layerId} = featureProperties;
        if (!highlightedFeaturesById.current[featureStateId]) {
            highlightedFeaturesById.current[featureStateId] = {
                ...featureProperties,
            };
        }
    }, [])

    const removeAllHighlighted = useCallback(() => {
        highlightedFeaturesById.current = {};
    }, [])

    const addHovered = useCallback((featureProperties: SelectedFeatureProperties) => {
        hoveredFeaturesRef.current.push(featureProperties);
    }, [])

    // const removeHovered = useCallback(() => {
    //
    // }, [])

    const value = {
        highlightedFeaturesById,
        hoveredFeaturesRef,
        addHighlighted,
        removeAllHighlighted,
        addHovered,
    }

    return (
        <FeaturesHighlightingContext.Provider value={value}>
            {children}
        </FeaturesHighlightingContext.Provider>
    );
};

export {FeaturesHighlightingContextProvider, useFeaturesHighlightingContext};